// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.word-view_frame[data-v-4331e9d5]{position:absolute; left:0; top:0; right:0; bottom:0; width:100%; height:100%; display:block;}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
